import { render, staticRenderFns } from "./modeifyPrice.vue?vue&type=template&id=126f5952&scoped=true"
import script from "./modeifyPrice.vue?vue&type=script&lang=js"
export * from "./modeifyPrice.vue?vue&type=script&lang=js"
import style0 from "./modeifyPrice.vue?vue&type=style&index=0&id=126f5952&prod&lang=less&scoped=true"
import style1 from "./modeifyPrice.vue?vue&type=style&index=1&id=126f5952&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126f5952",
  null
  
)

export default component.exports